import { RouteThunk } from "redux-first-router";
import { RootState } from "../ducks/reducers";

export function composeThunks(...thunks: RouteThunk<RootState>[]): RouteThunk<RootState> {
  return (dispatch, getState, bag) => {
    return Promise.all(thunks.map(thunk => thunk(dispatch, getState, bag)));
  };
}
